import { base_url } from "Zustand/constants";
import axios from "axios";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: base_url, // adjust if needed
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    if (config.url?.startsWith("http://")) {
      //config.url = config.url.replace("http://", "https://");
    }
    const token = localStorage.getItem("token"); // or whatever key you're using
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
